import React, { useState } from 'react';
import cn from 'classnames';

import ActivationBox from '../ActivationBox';
import ActivationPlansList from './ActivationPlansList';
import ActivationTerms from './ActivationTerms';
import Button from '../../../components/common/ui/Button';
import ActivationPaymentsList from '../ActivationPaymentsList';
import { filterSubCharges } from '../utils';
import { getDefaultSelectedPlanVariant } from './utils';

import styles from './styles.module.scss';

const ActivationSelectPlan = ({
  sub,
  products,
  restoredSelectedVariant,
  openCompleteScreen,
  openErrorScreen,
  openPaymentErrorScreen,
  openProcessingScreen,
  openOfflineScreen,
  subsCharges,
  activateNewLine,
}) => {
  const [productVariant, setProductVariant] = useState(
    restoredSelectedVariant || getDefaultSelectedPlanVariant(sub, products),
  );
  const [termsChecked, setTermsChecked] = useState(false);
  const [selectedPaymentMethodId, setSelectedPaymentMethodId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const subCharges = filterSubCharges(subsCharges, sub?.id);
  const isPendingCharge = subCharges.find(
    (charge) => charge.status === 'pending',
  );

  const toggleTermsChecked = () => setTermsChecked((value) => !value);

  const handleConfirm = () => {
    activateNewLine({
      paymentMethodId: selectedPaymentMethodId,
      productVariant,
      setLoading,
      setError,
      openErrorScreen,
      openCompleteScreen,
      openPaymentErrorScreen,
      openProcessingScreen,
      openOfflineScreen,
    });
  };

  return (
    <ActivationBox className={styles.wrapper}>
      <h3 className={cn('h3', styles.title)}>Setting a plan</h3>
      <div className={styles.content}>
        <ActivationPaymentsList
          sub={sub}
          selectedPaymentMethodId={selectedPaymentMethodId}
          setSelectedPaymentMethodId={setSelectedPaymentMethodId}
        />
        <ActivationPlansList
          sub={sub}
          products={products}
          productVariant={productVariant}
          setProductVariant={setProductVariant}
        />
      </div>
      <ActivationTerms
        termsChecked={termsChecked}
        toggleTermsChecked={toggleTermsChecked}
      />
      {error && <p className={cn('text-error', styles.error)}>{error}</p>}
      {isPendingCharge && (
        <p className={cn('text-error', styles.error)}>
          You have a processing payment. Please, wait for the end of a
          transaction before proceeding.
        </p>
      )}
      <Button
        onClick={handleConfirm}
        className={styles.button}
        disabled={!termsChecked || !productVariant || isPendingCharge}
        isLoading={loading}
      >
        Purchase
      </Button>
    </ActivationBox>
  );
};

export default ActivationSelectPlan;
